import { PasswordResetCodePage } from '@repo/ui';
import { usePasswordResetFlow } from 'presentation/app/contexts/PasswordResetFlowContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuthenticationVerifyCode } from '../hooks/useAuthenticationVerifyCode';
import { getEnv } from 'shared/get-env';

export const VerifyCodePage = () => {
  // hooks
  const navigate = useNavigate();
  const { state: flowState } = usePasswordResetFlow();
  const {
    requestSendPasswordResetCode,
    loadingAuthenticationVerifyCode,
    validationAuthenticationVerifyCode,
  } = useAuthenticationVerifyCode();

  // effect
  useEffect(() => {
    if (!flowState.cpf) {
      navigate('/redefinir-senha');
    }
  }, [flowState.cpf, navigate]);

  if (!flowState.cpf) {
    return null;
  }

  return (
    <PasswordResetCodePage
      flowState={flowState}
      img={getEnv('REACT_APP_URL_LOGO')}
      loading={loadingAuthenticationVerifyCode}
      validation={validationAuthenticationVerifyCode}
      requestSendPasswordResetCode={requestSendPasswordResetCode}
    />
  );
};
